import { FormikProvider, useFormik } from 'formik';
import { useEffect } from 'react';

import BackButton from '@perpay-web/components/base/BackButton/BackButton';
import BottomSheet from '@perpay-web/components/base/BottomSheet/BottomSheet';
import CustomButton from '@perpay-web/components/base/CustomButton/CustomButton';
import NonFieldErrors from '@perpay-web/components/base/NonFieldErrors/NonFieldErrors';
import FormikPhoneInput from '@perpay-web/components/base/PhoneInput/FormikPhoneInput';
import LegacyFocusLayout from '@perpay-web/components/composite/LegacyFocusLayout/LegacyFocusLayout';
import Stack from '@perpay-web/components/design-system/Stack/Stack';
import { PERPAY_TERMS_AND_CONDITIONS_URL } from '@perpay-web/constants/urls';
import { getClassName } from '@perpay-web/utils/domUtils';
import {
    validateForm,
    setPhoneNumberFormSchema,
} from '@perpay-web/validators/formBased';

import styles from './UpdatePhoneNumberModal.scss';

const defaultValues = {
    mobilePhone: '',
};

const UpdatePhoneNumberModal = ({
    className,
    errors = {},
    loading,
    onClose,
    clearBackendErrors,
    updatePhoneNumber,
    launchSupportTool,
    onLoadPageView,
}) => {
    const formik = useFormik({
        initialValues: defaultValues,
        onSubmit: (value) => {
            updatePhoneNumber(value.mobilePhone);
        },
        validate: (values) => validateForm(values, setPhoneNumberFormSchema),
    });

    const showErrors = Boolean(errors.message || errors.code);

    useEffect(() => {
        if (onLoadPageView) {
            onLoadPageView();
        }
    }, [onLoadPageView]);

    return (
        <BottomSheet
            onClose={onClose}
            className={getClassName(styles['modal-container'], className)}
            contentClassName={styles['bottom-sheet-content']}
            showClose={false}
            allowDismissal={false}
        >
            <div className={styles['modal-content']}>
                <FormikProvider value={formik}>
                    <form onSubmit={formik.handleSubmit}>
                        <BackButton
                            onClick={onClose}
                            className={styles['back-button']}
                        />
                        <LegacyFocusLayout
                            contentClassName={getClassName(
                                styles['form-focus-layout'],
                                styles['update-phone-content'],
                            )}
                            footerClassName={styles['modal-footer']}
                            footer={
                                <>
                                    <CustomButton
                                        type='submit'
                                        className={styles.button}
                                        loading={loading}
                                    >
                                        Update number
                                    </CustomButton>
                                    <CustomButton
                                        action='link'
                                        type='button'
                                        className={styles['button-link']}
                                        onClick={launchSupportTool}
                                    >
                                        Need help?
                                    </CustomButton>
                                </>
                            }
                        >
                            <div
                                className={getClassName(
                                    styles.description,
                                    styles.title,
                                )}
                            >
                                Update mobile number
                            </div>
                            <Stack>
                                <FormikPhoneInput
                                    label='Phone Number*'
                                    name='mobilePhone'
                                    errors={errors}
                                    numbersOnly
                                    onChange={clearBackendErrors}
                                />
                                {showErrors ? (
                                    <NonFieldErrors errors={errors} />
                                ) : null}
                                <p className={styles.copy}>
                                    By providing my phone number above, I
                                    consent to receive text messages from Perpay
                                    using automated technology. Consent is not a
                                    condition of purchase. For HELP reply HELP.
                                    To STOP receiving texts reply STOP. Message
                                    and data rates may apply. View our terms and
                                    privacy policy&nbsp;
                                    <span>
                                        <CustomButton
                                            action='inline-link'
                                            href={
                                                PERPAY_TERMS_AND_CONDITIONS_URL
                                            }
                                            target='_blank'
                                        >
                                            here.
                                        </CustomButton>
                                    </span>
                                </p>
                            </Stack>
                        </LegacyFocusLayout>
                    </form>
                </FormikProvider>
            </div>
        </BottomSheet>
    );
};

export default UpdatePhoneNumberModal;
